import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  IconButton,
  Typography,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";

import useVoidTransaction from "../../../hooks/useVoidTransaction";
import SFDialogTitle from "../../../components/SFDialogTitle";
import useSFAlert from "../../../hooks/useSFAlert";
import { useTranslate } from "react-admin";
import settings from "../../../utils/settings";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 667,
    height: 600,
    margin: "0 auto",
    paddingTop: 50,
  },
  title: {
    fontSize: 30,
    color: theme.orange,
  },
  dialogpaper: {
    margin: 0,
    width: 667,
    height: 600,
    maxWidth: 667,
    maxHeight: 500,
    borderRadius:12
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 20,
    boxSizing: "border-box",
    alignItems: "start",
  },
  toggleButtonGroup: {},
  toggleButton: {
    width: 180,
    height: 38,
  },
  selected: {
    backgroundColor: theme.orange + " !important",
    color: theme.white,
  },
  nonSelected: {
    color: theme.orange,
  },

  discountTextField: {
    marginTop: 31,
    width: 426,
    height: 66,
  },
  authorizeTextField: {
    width: 396,
    height: 66,
  },
  circleItem: {
    width: 77,
    height: 77,
    borderRadius: 37,
    borderWidth: 1,
    borderColor: "#b00020",
  },
  circleItemsContainer: {
    display: "flex",
    width: 500,
    padding: 10,
    marginTop: 17,
    justifyContent: "space-around",
    alignItems: "center",
  },
  dialogAction: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    margin: "0 !important",
  },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    margin: "0 !important",
    borderRadius: "0px 0px 12px 12px",
  },
  remark: {
    width: "100%",
    fontSize: 20,
  },
}));

const VoidDialog = ({ open, onClose, transactionNo, memberId, version }) => {
  const classes = useStyles();
  const { branchName } = settings();
  const [showPassword, setShowPassword] = useState(false);
  const [pin, setPin] = useState();
  const [remark, setRemark] = useState();
  const { voidTransaction } = useVoidTransaction();
  const translate = useTranslate();
  const [alert] = useSFAlert();
  if (version === null) {
    alert("Missing transaction version");
    return null;
  }
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      classes={{
        root: classes.allContainer,
        paper: classes.dialogpaper,
      }}
    >
      <SFDialogTitle
        id="customized-dialog-title"
        onClose={onClose}
        title="Void"
      />

      <DialogContent classes={{ root: classes.dialogContent }}>
        <Typography align="left" className={classes.alignLeft}>
          Remark
        </Typography>
        <TextField
          value={remark}
          variant="outlined"
          multiline
          rows={3}
          rowsMax={3}
          onChange={(e) => setRemark(e.target.value)}
          className={classes.remark}
        />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <TextField
          type={showPassword ? "text" : "password"}
          label="Authorization code"
          classes={{ root: classes.authorizeTextField }}
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          onClick={async () => {
            const result = await voidTransaction({
              transactionNo: transactionNo,
              pin: pin,
              memberId: memberId,
              version: version,
              remark: remark,
            });

            if (result.error)
              return alert(translate("ra.text.wrongAuthorizeCode"));
            if (result) {
              onClose();
              return window.location.reload();
            }
          }}
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
          disabled={!pin || branchName === "All"}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VoidDialog;
